export default "__VITE_ASSET__CaZVB4Oa__"